import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-muted fw-normal"
}
const _hoisted_2 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert-warning py-2 px-3 mb-3"
}
const _hoisted_4 = { class: "row row-cols-2 row-cols-md-5 g-2 mb-3" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "border rounded p-2 text-center h-100" }
const _hoisted_7 = { class: "fs-4 lh-1" }
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "border border-primary rounded p-2 text-center h-100" }
const _hoisted_11 = { class: "fs-4 lh-1 text-primary" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "border rounded p-2 text-center h-100" }
const _hoisted_15 = { class: "fs-4 lh-1" }
const _hoisted_16 = { class: "text-muted" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "border rounded p-2 text-center h-100" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "border rounded p-2 text-center h-100" }
const _hoisted_22 = { class: "fs-4 lh-1" }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "small text-muted mb-1 text-capitalize-first" }
const _hoisted_26 = {
  key: 0,
  class: "text-success small"
}
const _hoisted_27 = {
  key: 1,
  class: "d-flex flex-wrap gap-2"
}
const _hoisted_28 = ["title", "onClick"]
const _hoisted_29 = { class: "badge bg-light text-dark ms-1" }
const _hoisted_30 = {
  key: 0,
  class: "badge bg-secondary ms-1"
}
const _hoisted_31 = {
  key: 2,
  class: "small text-muted mt-1"
}
const _hoisted_32 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_33 = { class: "small text-muted text-capitalize-first" }
const _hoisted_34 = { class: "d-flex flex-wrap gap-2 mt-2" }
const _hoisted_35 = { class: "row g-2 align-items-center mb-2" }
const _hoisted_36 = { class: "col-auto" }
const _hoisted_37 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "col-12 col-md-4 col-lg-3" }
const _hoisted_40 = ["placeholder"]
const _hoisted_41 = { class: "col text-end small text-muted" }
const _hoisted_42 = {
  class: "overflow-auto border rounded",
  style: {"max-height":"42vh"}
}
const _hoisted_43 = { class: "table table-sm table-hover align-middle small mb-0" }
const _hoisted_44 = {
  class: "position-sticky top-0 bg-body",
  style: {"z-index":"1"}
}
const _hoisted_45 = { class: "text-capitalize-first" }
const _hoisted_46 = { class: "text-capitalize-first" }
const _hoisted_47 = { class: "text-capitalize-first" }
const _hoisted_48 = { class: "text-capitalize-first" }
const _hoisted_49 = { class: "text-capitalize-first" }
const _hoisted_50 = { class: "text-capitalize-first" }
const _hoisted_51 = { class: "text-capitalize-first" }
const _hoisted_52 = { class: "text-capitalize-first" }
const _hoisted_53 = { class: "text-capitalize-first" }
const _hoisted_54 = { class: "text-capitalize-first" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  colspan: "10",
  class: "text-center text-muted py-4"
}
const _hoisted_57 = { class: "text-nowrap" }
const _hoisted_58 = { class: "text-muted small" }
const _hoisted_59 = {
  key: 0,
  class: "badge bg-info text-dark ms-1"
}
const _hoisted_60 = { class: "text-nowrap" }
const _hoisted_61 = {
  key: 0,
  class: "badge bg-secondary ms-1"
}
const _hoisted_62 = ["title"]
const _hoisted_63 = {
  key: 0,
  class: "small text-muted text-wrap",
  style: {"max-width":"190px"}
}
const _hoisted_64 = { class: "text-nowrap" }
const _hoisted_65 = { class: "text-muted" }
const _hoisted_66 = {
  key: 0,
  class: "badge bg-light text-dark border ms-1"
}
const _hoisted_67 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_68 = { class: "text-nowrap" }
const _hoisted_69 = { class: "text-nowrap" }
const _hoisted_70 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_71 = { class: "text-nowrap" }
const _hoisted_72 = { class: "text-nowrap" }
const _hoisted_73 = { style: {"min-width":"230px"} }
const _hoisted_74 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_75 = ["title"]
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "small text-muted me-3" }
const _hoisted_78 = { class: "text-nowrap" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = ["disabled"]
const _hoisted_81 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    modelValue: _ctx.modelValue,
    "dialog-class": "rates-report-dialog",
    "body-class": "pt-0",
    "footer-class": "d-flex justify-content-between align-items-center",
    "no-close-on-backdrop": true,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(_ctx.helper.trans('rates_management.report.title')), 1),
        (_ctx.subtitle)
          ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(_ctx.subtitle), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.report)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.drift)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa fa-triangle-exclamation me-2" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.helper.trans('rates_management.report.drift')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.report.summary.matched), 1),
                  _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.helper.trans('rates_management.report.matched')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.report.summary.changed), 1),
                  _createElementVNode("small", _hoisted_12, _toDisplayString(_ctx.helper.trans('rates_management.report.will_change')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.report.summary.unchanged), 1),
                  _createElementVNode("small", _hoisted_16, _toDisplayString(_ctx.helper.trans('rates_management.report.unchanged')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["fs-4 lh-1", {'text-muted': _ctx.report.summary.skipped === 0}])
                  }, _toDisplayString(_ctx.report.summary.skipped), 3),
                  _createElementVNode("small", _hoisted_19, _toDisplayString(_ctx.helper.trans('rates_management.report.skipped')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.report.summary.tradersChanged), 1),
                  _createElementVNode("small", _hoisted_23, _toDisplayString(_ctx.helper.trans('rates_management.report.traders_changed')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.helper.trans('rates_management.report.warnings')), 1),
              (_ctx.report.summary.warnings.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-circle-check me-1" }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.helper.trans('rates_management.report.no_warnings')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.summary.warnings, (warning) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: warning.code,
                        type: "button",
                        class: _normalizeClass(["btn btn-sm text-nowrap", _ctx.chipClass(warning, _ctx.warningCodeFilter === warning.code)]),
                        title: _ctx.warningHint(warning.code, null),
                        onClick: ($event: any) => (_ctx.toggleWarningFilter(warning.code))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.helper.trans(`rates_management.warning.${warning.code}`)) + " ", 1),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(warning.count), 1),
                        (warning.isEstimate)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.helper.trans('rates_management.report.estimate')), 1))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_28))
                    }), 128))
                  ])),
              (_ctx.hasEstimates)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.helper.trans('rates_management.report.estimate_note')), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.report.summary.groups.length > 1)
              ? (_openBlock(), _createElementBlock("details", _hoisted_32, [
                  _createElementVNode("summary", _hoisted_33, _toDisplayString(_ctx.helper.trans('rates_management.report.groups')), 1),
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.summary.groups, (group) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: group.trafficGroupId,
                        class: "border rounded px-2 py-1 small"
                      }, [
                        _createTextVNode(_toDisplayString(group.trafficGroupName) + ": ", 1),
                        _createElementVNode("b", null, _toDisplayString(_ctx.helper.trans('rates_management.report.group_stats', {changed: group.changed, matched: group.matched})), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusFilters, (option) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: option,
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.statusFilter === option ? 'btn-primary' : 'btn-outline-secondary']),
                      onClick: ($event: any) => (_ctx.statusFilter = option)
                    }, _toDisplayString(_ctx.helper.trans(`rates_management.report.filter_${option}`)), 11, _hoisted_38))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  placeholder: _ctx.helper.trans('rates_management.report.search')
                }, null, 8, _hoisted_40), [
                  [_vModelText, _ctx.search]
                ])
              ]),
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.helper.trans('rates_management.report.filtered_from', {shown: _ctx.filteredRows.length, total: _ctx.report.rows.length})), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("table", _hoisted_43, [
                _createElementVNode("thead", _hoisted_44, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.helper.trans('rates_management.report.col_trader')), 1),
                    _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.helper.trans('rates_management.report.col_group')), 1),
                    _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.helper.trans('rates_management.report.col_status')), 1),
                    _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.helper.trans('rates_management.report.col_change')), 1),
                    _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.helper.trans('rates_management.report.col_fee')), 1),
                    _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.helper.trans('rates_management.report.col_cuts')), 1),
                    _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.helper.trans('rates_management.report.col_total')), 1),
                    _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.helper.trans('rates_management.report.col_cap')), 1),
                    _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.helper.trans('rates_management.report.col_store_min')), 1),
                    _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.helper.trans('rates_management.report.col_warnings')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.filteredRows.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                        _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.helper.trans('rates_management.report.no_rows')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRows, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: `${row.traderId}_${row.trafficGroupId}`,
                      class: _normalizeClass({'text-muted': row.status !== 'changed'})
                    }, [
                      _createElementVNode("td", _hoisted_57, [
                        _createTextVNode(_toDisplayString(row.traderName) + " ", 1),
                        _createElementVNode("span", _hoisted_58, "#" + _toDisplayString(row.traderId), 1),
                        (row.isProvider)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.helper.trans('rates_management.report.provider')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_60, [
                        _createTextVNode(_toDisplayString(row.trafficGroupName) + " ", 1),
                        (!row.enabled)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.helper.trans('rates_management.report.disabled')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.statusBadgeClass(row.status)]),
                          title: row.skipReason ? _ctx.helper.trans(`rates_management.skip_reason.${row.skipReason}`) : ''
                        }, _toDisplayString(_ctx.helper.trans(`rates_management.status.${row.status}`)), 11, _hoisted_62),
                        (row.skipReason)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.helper.trans(`rates_management.skip_reason.${row.skipReason}`)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_64, [
                        (row.oldValue !== null && row.newValue !== null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", _hoisted_65, _toDisplayString(row.oldValue) + "%", 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["mx-1", _ctx.deltaClass(row)])
                              }, _toDisplayString(_ctx.deltaArrow(row)), 3),
                              _createElementVNode("b", {
                                class: _normalizeClass(_ctx.deltaClass(row))
                              }, _toDisplayString(row.newValue) + "%", 3),
                              (row.cutIndex !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_66, "L" + _toDisplayString(row.cutIndex + 1), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_67, "-"))
                      ]),
                      _createElementVNode("td", _hoisted_68, _toDisplayString(row.fee) + "%", 1),
                      _createElementVNode("td", _hoisted_69, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cuts, (cut, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            (index > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_70, " / "))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: _normalizeClass({'fw-bold text-primary': row.cutIndex === index})
                            }, _toDisplayString(cut), 3)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("td", {
                        class: _normalizeClass(["text-nowrap", {'text-danger fw-bold': _ctx.isOverLimit(row)}])
                      }, _toDisplayString(row.total) + "%", 3),
                      _createElementVNode("td", _hoisted_71, _toDisplayString(row.teamLeadCap === null ? '-' : row.teamLeadCap + '%'), 1),
                      _createElementVNode("td", _hoisted_72, _toDisplayString(row.storeMin === null ? '-' : row.storeMin + '%'), 1),
                      _createElementVNode("td", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.warnings, (warning) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: warning.code,
                              class: _normalizeClass(["badge rounded-pill text-wrap text-start", warning.severity === 'warning' ? 'bg-warning text-dark' : 'bg-secondary']),
                              title: _ctx.warningHint(warning.code, warning.limit)
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.helper.trans(`rates_management.warning.${warning.code}`)), 1),
                              (warning.isEstimate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_76, " ~"))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_75))
                          }), 128))
                        ])
                      ])
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_77, [
        (_ctx.report && _ctx.report.summary.changed > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.helper.trans('rates_management.report.will_apply', {changed: _ctx.report.summary.changed, traders: _ctx.report.summary.tradersChanged})), 1)
            ], 64))
          : (_ctx.report)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.helper.trans('rates_management.report.nothing_to_apply')), 1)
              ], 64))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary btn-sm text-capitalize-first me-2",
          disabled: _ctx.applying,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        }, _toDisplayString(_ctx.helper.trans('rates_management.report.cancel')), 9, _hoisted_79),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-sm text-capitalize-first",
          disabled: _ctx.applying || !_ctx.report || _ctx.report.summary.changed === 0,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirm')))
        }, [
          (_ctx.applying)
            ? (_openBlock(), _createElementBlock("span", _hoisted_81))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('rates_management.report.confirm')), 1)
        ], 8, _hoisted_80)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}